import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/bonus-program',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/bonus-program',
      name: 'bonus-program',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/BonusProgram.vue')
    }

  ]
};
export default app;
